import React from 'react'

export default function Portrait(props) {
    return (
        <div >
            <img className={props.theme} src={props.image} alt="Not Here" />        
        </div>
    )
}
